<template>
  <div class="widget-guide-container">
    <div>
      <div class="alert" v-show="showGuide">
        <strong>⚠️ No widgets enabled yet!</strong>
        Follow these steps to configure your dashboard and enable dashboard widgets.
      </div>

      <section class="section">
        <h2><span class="emoji">📋</span> Getting Started</h2>
        <p style="color: #666; line-height: 1.8; margin-bottom: 15px">
          You currently have <strong>no widgets enabled</strong> on your dashboard. Follow the steps
          below to configure and customize your dashboard widgets.
        </p>
      </section>

      <section class="section">
        <h2><span class="emoji">🔧</span> Step-by-Step Instructions</h2>
        <div class="steps">
          <div class="step">
            <div class="step-title">
              <div class="step-number">1</div>
              <span>Access Dashboard Settings</span>
            </div>
            <div class="step-content">
              Navigate to your dashboard and look for the <strong>Settings icon (⚙️)</strong> in the
              bottom-left of navigation bar and click <strong> "Dashboard Widget"</strong> tab.
            </div>
          </div>

          <div class="step">
            <div class="step-title">
              <div class="step-number">2</div>
              <span>Dashboard Widget</span>
            </div>
            <div class="step-content">
              <ul>
                <li>
                  This allows you to enable or disable widgets:
                  <ul style="margin-top: 8px">
                    <li>
                      <strong>Employee Statistics</strong> — Overview of active employee statistics
                      including
                    </li>
                    <li>
                      <strong>Progress Statistics</strong> — Summary of workflow progress across all
                      activities
                    </li>
                    <li>
                      <strong>Case Analytics</strong> — Visual representation of case distribution
                    </li>
                    <li><strong>Visit Analytics</strong> — Visual breakdown of visit statuses</li>
                    <li>
                      <strong>Top Collected Visits</strong> — Highest-performing visits overview
                    </li>
                    <li>
                      <strong>Tele Calling Activity</strong> — Calls: total, Received by agent,
                      Received by customer
                    </li>

                    <li>
                      <strong>Loan Statistics</strong> — Comprehensive loan portfolio overview
                    </li>
                    <li>
                      <strong>EMI Statistics</strong> — Summary of Equated Monthly Installment (EMI)
                      activity
                    </li>
                    <li><strong>Recent EMI Transactions</strong> — Latest EMI payment history</li>
                    <li>
                      <strong>EMI Management Actions</strong> — Quick actions for EMI operations
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <p style="margin-top: 20px; color: #4b5b9f; font-weight: 600">
          💡 Your dashboard will update in real-time once you enable widgets!
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetSettingsGuide',
  props: {
    showGuide: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.widget-guide-container {
  max-width: 1000px;
  margin: 0 auto;
  background: white;
  overflow: hidden;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.alert {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 16px;
  margin-bottom: 30px;
  border-radius: 4px;
  color: #856404;
}

.alert strong {
  display: block;
  margin-bottom: 8px;
}

.section {
  margin-bottom: 40px;
}

.section h2 {
  color: #4b5b9f;
  font-size: 1.2em;
  margin-bottom: 20px;
  display: flex;
  font-weight: 800;
  align-items: center;
  gap: 10px;
}

.emoji {
  font-size: 1.2em;
}

.steps {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 8px;
  border-left: 4px solid #4b5b9f;
}

.step {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
}

.step:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.step-title {
  color: #333;
  font-weight: 600;
  font-size: 1.1em;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.step-number {
  background: #4b5b9f;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9em;
}

.step-content {
  margin-left: 36px;
  color: #555;
  line-height: 1.6;
}

.step-content ul {
  margin-top: 10px;
  margin-left: 20px;
}

.step-content li {
  margin-bottom: 8px;
}

.widgets-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: white;
}

.widgets-table th {
  background: #667eea;
  color: white;
  padding: 16px;
  text-align: left;
  font-weight: 600;
}

.widgets-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e9ecef;
}

.widgets-table tr:hover {
  background: #f8f9fa;
}

.widget-name {
  font-weight: 600;
  color: #333;
}

.widget-desc {
  color: #666;
  font-size: 0.95em;
}

footer {
  background: #f8f9fa;
  padding: 20px;
  text-align: center;
  color: #666;
  border-top: 1px solid #e9ecef;
}

@media (max-width: 768px) {
  header h1 {
    font-size: 2em;
  }

  .widgets-table {
    font-size: 0.9em;
  }

  .widgets-table th,
  .widgets-table td {
    padding: 10px;
  }
}
</style>
